import React, { useEffect, useRef, useState, useCallback } from "react";
import "./TicketsParMagasin.css";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

/* ─── Types ─────────────────────────────────────────────── */
interface TicketInfo {
  id: number;
  Probleme: string;
  Description: string;
  Status: string;
  NamUtilisateur: string;
  Date: string;
  IdClient?: number;
}

interface ChatMessage {
  id: number;
  IdTicket: number;
  NamUtilisateur: string;
  Message: string;
  sender_type: "magasin" | "client";
  Date: string;
}

/* ─── Inline CSS ──────────────────────────────────────────── */
const CHAT_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

.chat-root { font-family:'Inter',sans-serif; background:#F0F4F8; min-height:100vh; }

.chat-page {
  max-width: 820px;
  margin: 0 auto;
  padding: 32px 20px 80px;
}

/* header */
.chat-hdr {
  display:flex; align-items:center; gap:14px; margin-bottom:28px;
  animation: cu .35s ease both;
}
.chat-back {
  width:38px; height:38px; border-radius:10px;
  border:1.5px solid #E2E8F0; background:#fff;
  display:flex; align-items:center; justify-content:center;
  cursor:pointer; color:#64748B;
  transition:background .15s,border-color .15s,color .15s;
  flex-shrink:0; text-decoration:none;
}
.chat-back:hover { background:#0A0F1E; border-color:#0A0F1E; color:#fff; }
.chat-hdr-info h2 { font-size:1.25rem; font-weight:800; color:#0F172A; margin:0; }
.chat-hdr-info p  { font-size:.8rem; color:#94A3B8; margin:2px 0 0; }

/* ticket meta bar */
.chat-meta {
  display:flex; gap:12px; flex-wrap:wrap; align-items:center;
  background:#fff; border:1.5px solid #E2E8F0; border-radius:14px;
  padding:14px 18px; margin-bottom:18px;
  animation: cu .35s .05s ease both;
}
.chat-meta-id { font-size:.72rem; font-weight:700; color:#64748B; background:#F1F5F9; padding:3px 9px; border-radius:6px; }
.chat-meta-status {
  font-size:.72rem; font-weight:700; padding:3px 11px; border-radius:20px;
}
.chat-meta-client { font-size:.82rem; font-weight:600; color:#0F172A; margin-left:auto; }
.chat-meta-date   { font-size:.75rem; color:#94A3B8; }

/* status change select */
.chat-status-select {
  padding:5px 10px; border:1.5px solid #E2E8F0; border-radius:8px;
  font-size:.75rem; font-weight:600; font-family:'Inter',sans-serif;
  background:#fff; cursor:pointer; outline:none;
  transition:border-color .18s;
  margin-left:8px;
}
.chat-status-select:focus { border-color:#0A0F1E; }

/* chat window */
.chat-window {
  background:#fff; border:1.5px solid #E2E8F0; border-radius:18px;
  overflow:hidden; display:flex; flex-direction:column;
  min-height:480px; max-height:600px;
  animation: cu .35s .1s ease both;
  box-shadow: 0 4px 24px rgba(10,15,30,.07);
}

/* window header */
.chat-win-hdr {
  padding:16px 20px;
  background:linear-gradient(135deg,#0A0F1E 0%,#1E293B 100%);
  display:flex; align-items:center; gap:12px; flex-shrink:0;
}
.chat-win-avatar {
  width:40px; height:40px; border-radius:50%;
  background:#F59E0B; display:flex; align-items:center; justify-content:center;
  font-size:.95rem; font-weight:800; color:#0A0F1E; flex-shrink:0;
}
.chat-win-name  { font-size:.92rem; font-weight:700; color:#fff; }
.chat-win-badge {
  margin-left:auto; display:flex; align-items:center; gap:6px;
  font-size:.75rem; color:#4ADE80;
}
.chat-win-dot { width:7px; height:7px; border-radius:50%; background:#4ADE80; }

/* messages area */
.chat-msgs {
  flex:1; overflow-y:auto; padding:20px 18px;
  background:#F8FAFC; display:flex; flex-direction:column; gap:12px;
  scroll-behavior:smooth;
}
.chat-msgs::-webkit-scrollbar { width:4px; }
.chat-msgs::-webkit-scrollbar-thumb { background:#CBD5E1; border-radius:4px; }

/* initial description bubble */
.chat-desc-bubble {
  align-self:flex-start;
  background:#EEF2FF; border:1.5px solid #C7D2FE;
  border-radius:6px 16px 16px 16px;
  padding:12px 16px; max-width:72%; font-size:.87rem; color:#3730A3;
  line-height:1.65;
}
.chat-desc-label { font-size:.68rem; font-weight:700; text-transform:uppercase; letter-spacing:.7px; color:#6366F1; margin-bottom:6px; }

/* message bubbles */
.chat-bubble-wrap { display:flex; gap:10px; align-items:flex-end; }
.chat-bubble-wrap.mine { flex-direction:row-reverse; }

.chat-avatar-sm {
  width:30px; height:30px; border-radius:50%; flex-shrink:0;
  display:flex; align-items:center; justify-content:center;
  font-size:.72rem; font-weight:700;
}
.chat-avatar-client  { background:#F59E0B; color:#0A0F1E; }
.chat-avatar-magasin { background:#0A0F1E; color:#fff; }

.chat-bubble {
  padding:10px 14px; border-radius:6px 16px 16px 16px;
  max-width:68%; font-size:.87rem; line-height:1.65;
  box-shadow:0 1px 3px rgba(0,0,0,.07);
}
.chat-bubble.mine { border-radius:16px 6px 16px 16px; }

.chat-bubble-client  { background:linear-gradient(135deg,#FEF3C7,#FDE68A); color:#1A1A1A; }
.chat-bubble-magasin { background:#fff; border:1.5px solid #E2E8F0; color:#1E293B; }

.chat-time { font-size:.65rem; color:#94A3B8; margin-top:4px; display:block; }

/* empty state */
.chat-empty { text-align:center; padding:40px 20px; color:#94A3B8; font-size:.85rem; }

/* spinner */
.chat-spin-wrap { display:flex; align-items:center; justify-content:center; padding:60px; }
.chat-spin { width:28px; height:28px; border:3px solid #E2E8F0; border-top-color:#F59E0B; border-radius:50%; animation:cspin .8s linear infinite; }

/* typing dots */
.chat-typing { display:flex; gap:5px; align-items:center; padding:10px 16px; }
.chat-typing span {
  width:7px; height:7px; border-radius:50%; background:#CBD5E1; display:inline-block;
  animation:ctype 1.2s ease-in-out infinite;
}
.chat-typing span:nth-child(2) { animation-delay:.2s; }
.chat-typing span:nth-child(3) { animation-delay:.4s; }

/* reply box */
.chat-reply {
  padding:14px 16px; border-top:1.5px solid #E2E8F0; background:#fff;
  display:flex; gap:10px; align-items:flex-end; flex-shrink:0;
}
.chat-reply-input {
  flex:1; min-height:44px; max-height:120px; overflow-y:auto;
  border:1.5px solid #E2E8F0; border-radius:12px; padding:10px 14px;
  font-family:'Inter',sans-serif; font-size:.88rem; color:#0F172A;
  resize:none; outline:none; transition:border-color .18s;
  line-height:1.5;
}
.chat-reply-input:focus { border-color:#0A0F1E; }
.chat-reply-input::placeholder { color:#CBD5E1; }

.chat-send-btn {
  width:42px; height:42px; border-radius:50%; border:none;
  background:#F59E0B; color:#0A0F1E;
  display:flex; align-items:center; justify-content:center;
  cursor:pointer; flex-shrink:0;
  transition:background .18s,transform .15s;
  font-size:.9rem;
}
.chat-send-btn:hover:not(:disabled) { background:#E6AE00; transform:scale(1.06); }
.chat-send-btn:disabled { background:#E2E8F0; color:#94A3B8; cursor:not-allowed; }

@keyframes cu    { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:none} }
@keyframes cspin { to{transform:rotate(360deg)} }
@keyframes ctype {
  0%,60%,100%{transform:translateY(0)}
  30%{transform:translateY(-6px)}
}
`;

/* ─── Status badge style ─────────────────────────────────── */
function statusStyle(s: string): React.CSSProperties {
  const m: Record<string, [string, string]> = {
    "Non lu": ["#FEF3C7", "#92400E"],
    "Lu":     ["#EEF2FF", "#3730A3"],
    "Résolu": ["#D1FAE5", "#065F46"],
    "Fermé":  ["#F1F5F9", "#475569"],
  };
  const [bg, color] = m[s] ?? ["#F1F5F9", "#475569"];
  return { background: bg, color };
}

/* ─── Component ──────────────────────────────────────────── */
export default function ConversationTiketsByMagasin() {
  const { id: ticketId } = useParams<{ id: string }>();
  const [ticket, setTicket] = useState<TicketInfo | null>(null);
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [input, setInput] = useState("");
  const [statusUpdating, setStatusUpdating] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const pollRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const magasinId   = localStorage.getItem("MagasinId")   ?? "";
  const magasinName = localStorage.getItem("MagasinName") ?? "Magasin";

  const fetchMessages = useCallback(async () => {
    if (!ticketId) return;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_PHP_APP_URL}/ticket/${ticketId}/messages`
      );
      setTicket(res.data.ticket);
      setMessages(res.data.messages ?? []);
    } catch {
      /* silently ignore poll errors */
    } finally {
      setLoading(false);
    }
  }, [ticketId]);

  /* Initial fetch + polling every 5 s */
  useEffect(() => {
    fetchMessages();
    pollRef.current = setInterval(fetchMessages, 5000);
    return () => { if (pollRef.current) clearInterval(pollRef.current); };
  }, [fetchMessages]);

  /* Auto-scroll to bottom */
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = async () => {
    const text = input.trim();
    if (!text || sending) return;
    setInput("");
    setSending(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/magasin/${magasinId}/answer/send`,
        { Message: text, NamUtilisateur: magasinName, IdTicket: Number(ticketId) }
      );
      await fetchMessages();
    } catch {
      setInput(text); // restore on error
    } finally {
      setSending(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSend(); }
  };

  const handleStatusChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newStatus = e.target.value;
    if (!ticket) return;
    setStatusUpdating(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/ticket/${ticketId}/status`,
        { status: newStatus }
      );
      setTicket(t => t ? { ...t, Status: newStatus } : t);
    } catch {
      /* ignore */
    } finally {
      setStatusUpdating(false);
    }
  };

  const fmtDate = (d: string) =>
    new Date(d).toLocaleString("fr-FR", { day:"2-digit", month:"short", hour:"2-digit", minute:"2-digit" });

  return (
    <>
      <NewSideBarMagasins />
      <style>{CHAT_CSS}</style>
      <div className="chat-root">
        <div className="chat-page">

          {/* ── Header ── */}
          <div className="chat-hdr">
            <Link to="/magasins/tickets" className="chat-back">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </Link>
            <div className="chat-hdr-info">
              <h2>Conversation Ticket #{ticketId}</h2>
              <p>Support client en temps réel</p>
            </div>
          </div>

          {/* ── Ticket meta ── */}
          {ticket && (
            <div className="chat-meta">
              <span className="chat-meta-id">TK-{ticket.id}</span>
              <span className="chat-meta-status" style={statusStyle(ticket.Status)}>
                {ticket.Status}
              </span>
              <span className="chat-meta-date">
                {new Date(ticket.Date).toLocaleString("fr-FR")}
              </span>
              <span className="chat-meta-client">
                👤 {ticket.NamUtilisateur}
              </span>
              <select
                className="chat-status-select"
                value={ticket.Status}
                onChange={handleStatusChange}
                disabled={statusUpdating}
              >
                <option value="Non lu">Non lu</option>
                <option value="Lu">Lu</option>
                <option value="Résolu">Résolu</option>
                <option value="Fermé">Fermé</option>
              </select>
            </div>
          )}

          {/* ── Chat window ── */}
          <div className="chat-window">

            {/* Window header */}
            <div className="chat-win-hdr">
              <div className="chat-win-avatar">
                {(ticket?.NamUtilisateur ?? "C")[0].toUpperCase()}
              </div>
              <div>
                <div className="chat-win-name">{ticket?.NamUtilisateur ?? "Client"}</div>
                <div style={{ fontSize: ".75rem", color: "#94A3B8" }}>
                  {ticket?.Probleme}
                </div>
              </div>
              <div className="chat-win-badge">
                <span className="chat-win-dot" />
                En ligne
              </div>
            </div>

            {/* Messages */}
            <div className="chat-msgs">
              {loading ? (
                <div className="chat-spin-wrap"><div className="chat-spin" /></div>
              ) : (
                <>
                  {/* Original description as first bubble */}
                  {ticket && (
                    <div>
                      <div className="chat-desc-label">Message initial</div>
                      <div className="chat-desc-bubble">{ticket.Description}</div>
                      <span className="chat-time" style={{ marginLeft: 4 }}>
                        {fmtDate(ticket.Date)}
                      </span>
                    </div>
                  )}

                  {messages.length === 0 && (
                    <div className="chat-empty">
                      Aucun message de suivi pour l'instant.<br />
                      Répondez ci-dessous pour commencer la conversation.
                    </div>
                  )}

                  {messages.map(msg => {
                    const isMine = msg.sender_type === "magasin";
                    return (
                      <div
                        key={msg.id}
                        className={`chat-bubble-wrap${isMine ? " mine" : ""}`}
                      >
                        <div className={`chat-avatar-sm ${isMine ? "chat-avatar-magasin" : "chat-avatar-client"}`}>
                          {msg.NamUtilisateur[0]?.toUpperCase()}
                        </div>
                        <div>
                          <div className={`chat-bubble ${isMine ? "chat-bubble-magasin mine" : "chat-bubble-client"}`}>
                            {msg.Message}
                          </div>
                          <span className="chat-time" style={{ textAlign: isMine ? "right" : "left" }}>
                            {msg.NamUtilisateur} · {fmtDate(msg.Date)}
                          </span>
                        </div>
                      </div>
                    );
                  })}

                  {sending && (
                    <div className="chat-bubble-wrap mine">
                      <div className="chat-avatar-sm chat-avatar-magasin">
                        {magasinName[0]?.toUpperCase()}
                      </div>
                      <div className="chat-bubble chat-bubble-magasin mine">
                        <div className="chat-typing">
                          <span /><span /><span />
                        </div>
                      </div>
                    </div>
                  )}

                  <div ref={messagesEndRef} />
                </>
              )}
            </div>

            {/* Reply box */}
            <div className="chat-reply">
              <textarea
                className="chat-reply-input"
                rows={1}
                placeholder="Votre réponse… (Entrée pour envoyer)"
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button
                className="chat-send-btn"
                onClick={handleSend}
                disabled={!input.trim() || sending}
              >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                </svg>
              </button>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}